import {
    CHANGE_EXTERNAL_ID,
    CHECK_CHANGE,
    CHECK_CUSTOMER_REQUEST,
    CHECK_SELECT_ALL, CLOSE_POPUP,
    CONFIG_REQUEST, DISABLED_BTN, ERROR_POPUP, HOVER_ALL, MOBILE_GUIDES, MOBILE_MENU, MOBILE_MENU_OPEN_ITEM,
    SAVE_REQUEST,
    SUBSCRIPTIONS_REQUEST
} from "./types";

export function checkCustomerRequestFunction(email, marker) {
    if (email.length > 0) {
        let new_email = encodeURIComponent(email);
        let new_marker = encodeURIComponent(marker);
        return async dispatch => {
            await fetch(`https://subscriptions.travelpayouts.com/api.php?method=CheckCustomer&code=BlIABLEmeLeNIEtoLYceldConfAiNdOB&email=${new_email}&marker=${new_marker}`, {
                method: 'GET',
            }).then(res => res.json()).then((result) => {
                if (result.customer !== undefined && result.customer.ids !== undefined && result.customer.ids.marker !== undefined) {
                    console.log(result.customer.area);
                    if (result.customer.area === undefined) {
                        result.customer.area = {ids: {externalId: 'en'}, name: 'En'};
                    }
                    if (marker !== parseInt(result.customer.ids.marker)) {
                        dispatch({type: ERROR_POPUP, payload: 'email_not_found'})
                    } else {
                        dispatch({type: CHECK_CUSTOMER_REQUEST, payload: {customer: result.customer}})
                    }
                } else {
                    dispatch({type: ERROR_POPUP, payload: 'email_not_found'})
                }
            }, (error) => {
                dispatch({type: ERROR_POPUP, payload: 'email_not_found'})
            });
        }
    }
}

export function subscriptionsRequestFunction() {

    return async dispatch => {
        await fetch('https://subscriptions.travelpayouts.com/api.php?method=subscriptions&code=LimEntylACesTRYTIONGThoRTyPortAG', {
            method: 'GET',
        }).then(res => res.json()).then((result) => {
            dispatch({type: SUBSCRIPTIONS_REQUEST, payload: result.records})
        }, (error) => {
            console.log(error)
        });
    }
}

export function configRequestFunction() {

    return async dispatch => {
        await fetch('https://subscriptions.travelpayouts.com/api.php?method=config&code=LimEntylACesTRYTIONGThoRTyPortAG', {
            method: 'GET',
        }).then(res => res.json()).then((result) => {
            dispatch({type: CONFIG_REQUEST, payload: result.records})
        }, (error) => {
            console.log(error)
        });
    }
}

export function checkChange(item, index) {
    let isSubscribed = !item.isSubscribed;
    return async dispatch => {
        dispatch({type: CHECK_CHANGE, payload: {isSubscribed: isSubscribed, index: index}})
    }
}

export function selectAll() {
    return async dispatch => {
        dispatch({type: CHECK_SELECT_ALL, payload: null})
    }
}

export function checkboxesSave(customer, subscriptions, userEmail, userMarker, area) {
    return async dispatch => {
        dispatch({type: DISABLED_BTN, payload: null})
        let new_email = encodeURIComponent(userEmail);
        let new_marker = encodeURIComponent(userMarker);
        let data = {
            customer: {
                email: userEmail,
                area: area,
                subscriptions: subscriptions
            }
        }

        await fetch(`https://subscriptions.travelpayouts.com/api.php?method=EditCustomer&code=BlIABLEmeLeNIEtoLYceldConfAiNdOB&email=${new_email}&marker=${new_marker}`, {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify(data)
        }).then(res => res.json()).then((result) => {
            dispatch({type: SAVE_REQUEST, payload: null})
        }, (error) => {
            console.log(error)
        });
    }
}

export function closePopup() {
    return async dispatch => {
        dispatch({type: CLOSE_POPUP, payload: null})
    }
}

export function airtable_config_get_label(config, key, lang) {
    for (let i = 0; i < config.length; i++) {
        if (config[i].fields.id && config[i].fields.locale && config[i].fields.label) {
            if (config[i].fields.id === key && config[i].fields.locale === lang) {
                return config[i].fields.label;
            }
        }
    }
    return null;
}

export function airtable_config_get_link(config, key, lang) {
    for (let i = 0; i < config.length; i++) {
        if (config[i].fields.id && config[i].fields.locale && config[i].fields.label) {
            if (config[i].fields.id === key && config[i].fields.locale === lang) {
                return config[i].fields.link;
            }
        }
    }
    return null;
}


export function mobile_menu(checked) {
    return async dispatch => {
        dispatch({type: MOBILE_MENU, payload: !checked})
    }
}

export function changeExternalId(lang) {
    return async dispatch => {
        dispatch({type: CHANGE_EXTERNAL_ID, payload: lang})
    }
}

export function hoverAll(hover) {
    return async dispatch => {
        dispatch({type: HOVER_ALL, payload: hover})
    }
}

export function menuOpenItem(item) {
    return async dispatch => {
        dispatch({type: MOBILE_MENU_OPEN_ITEM, payload: item})
    }
}

export function mobile_guides(checked) {
    return async dispatch => {
        dispatch({type: MOBILE_GUIDES, payload: !checked})
    }
}